import { Link, useHistory } from "react-router-dom/cjs/react-router-dom"
import { colors } from "../../../../../utils/constants/colors"
import { extractLastParagraphNote, formatRelativeDate } from "../../../../../services/helper"
import { useContext, useState } from "react"
import { modifyNotification } from "../../../../../redux/actions/notification"
import { toast } from "../../../../CommonComponents/ToastComponent/toast"
import { useDispatch } from "react-redux"
import { AppContext } from "../../../../../context"

const RejectedSupplier = ({ key, notification, currentPage, setCurrentPage, subTab, setSelectedNotification, setCheckedKeys, action }) => {
    const history = useHistory()
    const dispatch = useDispatch()
        const {
            getNewUnreadNotification
        } = useContext(AppContext);

    const [showNoteModal, setShowNoteModal] = useState(false)
    const [showActionModal, setShowActionModal] = useState(false)

    const [checked, setChecked] = useState(false)

    let extractNote = extractLastParagraphNote(notification?.qaRejectionNotes)

    let time = formatRelativeDate(notification?.notificationCreatedAt)
    const seeMoreHandler = () => {
        setShowNoteModal(true)
    }

    const onClosehandler = () => {
        setShowNoteModal(false)
        setShowActionModal(false)
    }

    const onDetailHandler = async (listSupplierId) => {
        let notificationIds = []
        notificationIds.push(notification?.id)
        const updateResult = await dispatch(modifyNotification(notificationIds, "markAsRead")).then((res) => res).catch((err) => {
            getNewUnreadNotification()

            if (err) {
                toast.show({
                    title: 'Danger',
                    description: 'Unable To Modify From Unread To Read'
                })
            }
        })
        history.push(`/lists/insequence/addcallerdetails/${listSupplierId}`)
    }

    const checkHandler = (checked, notificationId) => {
        setChecked(checked)
        checked ? setCheckedKeys(prevState => [...prevState, notificationId]) : setCheckedKeys(prevState => prevState?.filter(id => id !== notificationId))
    }

    return (
        <div key={key} className={`container-fluid py-2 py-3 d-flex column-gap-3 mb-3 rounded ${!notification?.isRead && 'border'}`} style={{ backgroundColor: notification?.isRead ? 'aliceblue' : 'white' }}>
            <div className="d-flex column-gap-4 col-1 align-items-center">
                <button className="rounded-circle border p-2" style={{ width: '50px', height: '50px' }}><i class="bi bi-person-square fs-2"></i></button>
                <input type="checkbox" style={{ width: 15, height: 15 }} onChange={(e) => { checkHandler(e?.target?.checked) }} checked={checked} />
            </div>
            <div className="col-2 d-flex column-gap-2  align-self-center ">
                {
                    <Link
                        to={`/lists/insequence/addcallerdetails/${notification?.listSupplierId}`}
                        className="m-0"
                        style={{ fontSize: 14, color: colors.linkBlue }} target='_blank'
                    >
                        {notification?.suppliername}
                    </Link>
                }
            </div>
            <div className="col-5  align-self-center ">
                {
                    extractNote?.length > 50 ? <div className="d-flex align-item-center column-gap-4">
                        <p className="m-0 fw-bold" style={{ fontSize: 14, alignSelf: "center" }}> {extractNote?.slice(0, 100) + '...'}</p>
                        <p className="m-0 " style={{ fontSize: 14, color: `#0d6efd`, textDecoration: 'underline', cursor: 'pointer' }} onClick={seeMoreHandler}>See More</p>
                    </div> : <p className="m-0 fw-bold" style={{ fontSize: 14, alignSelf: "center" }}> {extractNote ? extractNote : 'No Notes'}</p>
                }
            </div>
            <div className="col-1  align-self-center ">
                <p className="m-0 fw-bold" style={{ fontSize: 14 }}>{time}</p>
            </div>
            <div className="col-1  align-self-center ">
                <p className="m-0 fw-bold" style={{ fontSize: 14 }}>{notification?.isRead ? 'Read' : 'Unread'}</p>
            </div>
            <div className="col-1  align-self-center">
                <button className="report_small_button_success" onClick={() => { onDetailHandler(notification?.listSupplierId) }}>Details</button>
            </div>
        </div>
    )
}

export default RejectedSupplier